import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import WithModal from "Components/withModal";
import isUndefined from "lodash/isUndefined";
import React, { useCallback, useEffect, useState } from "react";
import AccessLevelsEditor from "./accessLevelsEditor";
import locale from "./accessLevelsEditorPanel.locale";
export const SIZES = {
    MODAL_WIDTH: 560,
    MODAL_HEIGHT: 244
};
export default function AccessLevelsEditorPanel(props) {
    const [show, setShow] = useState(false);
    useEffect(() => {
        props.accessLevelsKey &&
            !props.data &&
            props.onInitialized &&
            props.onInitialized(props.entityId, props.entityType);
        setShow(!isUndefined(props.accessLevelsKey));
    }, [props.accessLevelsKey]);
    const handleHideModal = useCallback(() => {
        props.onClose && props.onClose();
    }, [props.onClose]);
    const handleClose = useCallback(() => {
        props.onClose && props.onClose();
    }, [props.onClose]);
    return (React.createElement(WithModal, { show: show, onHide: handleHideModal, contentClassName: "modal-padding", shadingColor: shadingLightestColor, className: "bg-blur", title: locale.TITLE, defaultWidth: SIZES.MODAL_WIDTH, defaultHeight: SIZES.MODAL_HEIGHT, isLoading: props.inProgress },
        React.createElement(AccessLevelsEditor, { onHide: handleClose, data: props.data, entityId: props.entityId, entityType: props.entityType, userCreate: props.userCreate })));
}
